/* eslint-disable import/prefer-default-export */
import AuthService from 'root/lib/authService';

export const logOutUser = () => AuthService.logoutTo(window.location.origin);
